import { render } from "./SubheaderWithColour.vue?vue&type=template&id=a7642bc2&scoped=true"
import script from "./SubheaderWithColour.vue?vue&type=script&lang=js"
export * from "./SubheaderWithColour.vue?vue&type=script&lang=js"

import "./SubheaderWithColour.vue?vue&type=style&index=0&id=a7642bc2&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7642bc2"]])

export default __exports__